/**
 * TV / kiosk açılışı (#570): `/?dashboard=<id>[,<id>…]&rotate=60&fullscreen=1`.
 * Kabuk (menü, sekmeler, başlık) hiç çizilmez; panolar tam sayfa, sırayla döner.
 * Tarayıcı `--kiosk` ile açıldıysa zaten tam ekrandır; `fullscreen=1` yalnız dener.
 */
export interface KioskParams {
  ids: string[];
  rotateSec: number;
  fullscreen: boolean;
}

export const DEFAULT_ROTATE_SEC = 60;

export function parseKioskParams(search: URLSearchParams): KioskParams | null {
  const raw = search.get('dashboard');
  if (!raw) return null;
  const ids = raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  if (!ids.length) return null;
  const rotate = Number(search.get('rotate'));
  return {
    ids,
    rotateSec: Number.isFinite(rotate) && rotate >= 10 ? Math.floor(rotate) : DEFAULT_ROTATE_SEC,
    fullscreen: search.get('fullscreen') === '1' || search.get('fullscreen') === 'true',
  };
}

/**
 * Kiosk adresini üretir (pano ekranındaki Kiosk menüsü, Ayarlar'daki bağlantı).
 * `base` uygulamanın kök adresi (origin + BASE_URL); sorgu dizesi eklenir.
 */
export function buildKioskUrl(base: string, ids: string[], rotateSec = DEFAULT_ROTATE_SEC): string {
  const url = new URL(base);
  url.search = '';
  url.hash = '';
  url.searchParams.set('dashboard', ids.join(','));
  if (ids.length > 1) url.searchParams.set('rotate', String(rotateSec));
  url.searchParams.set('fullscreen', '1');
  return url.toString().replace(/%2C/gi, ',');
}

/** Uygulamanın kök adresi (Vite BASE_URL alt dizinde yayınlansa da doğru olsun). */
export function appBaseUrl(): string {
  return new URL(import.meta.env.BASE_URL || '/', window.location.origin).toString();
}

/** Sıradaki pano dizini (tek panoda hep 0). */
export function nextIndex(current: number, count: number): number {
  return count > 0 ? (current + 1) % count : 0;
}
